import { Cookies } from 'react-cookie';

import { UnmountedHubResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getUnmountedHubs = async (siteSlug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const response = await axiosInterceptor.get(`api/v1/hubs/site/${siteSlug}/unmounted-hub`, {
    headers: {
      Authorization: token,
    },
  });
  return response.data as UnmountedHubResponse;
};
